module.exports = __webpack_public_path__ + "img/eivind-berre-p.53569618.webp";